// Module
var code = "<employees-dosimetry-badge user-uuid=\"{{employee.uuid}}\"></employees-dosimetry-badge>\n";
// Exports
module.exports = code;